import React from 'react';
import { BaseIcon } from './BaseIcon';

export const DownloadJobLogsIcon: React.FC = () => {
  return (
    <BaseIcon
      title="Browse Job Log File"
      paths={{
        d: 'M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z',
      }}
    />
  );
};
